import * as React from 'react'

const SvgComponent = props => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 11.829C1 6.4 5.928 2 12 2s11 4.427 11 9.855c0 5.428-4.928 9.816-11 9.816a12.053 12.053 0 01-4.811-.988L3.172 22h-.093a.328.328 0 01-.293-.216.407.407 0 01.047-.39 9.175 9.175 0 001.378-2.635C2.25 17.132 1.065 14.574 1 11.829zm20.482 0c0-4.48-4.25-8.116-9.482-8.116-5.231 0-9.482 3.636-9.482 8.116.047 2.213.995 4.278 2.569 5.6.49.437.69 1.17.502 1.844v.131l1.168-.395c.141-.041.286-.063.432-.066.187.002.372.038.549.106 1.36.591 2.805.89 4.262.883 5.231 0 9.482-3.624 9.482-8.103z"
      fill="#231815"
    />
    <mask
      id="prefix__a"
      maskUnits="userSpaceOnUse"
      x={1}
      y={2}
      width={22}
      height={20}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 11.829C1 6.4 5.928 2 12 2s11 4.427 11 9.855c0 5.428-4.928 9.816-11 9.816a12.053 12.053 0 01-4.811-.988L3.172 22h-.093a.328.328 0 01-.293-.216.407.407 0 01.047-.39 9.175 9.175 0 001.378-2.635C2.25 17.132 1.065 14.574 1 11.829zm20.482 0c0-4.48-4.25-8.116-9.482-8.116-5.231 0-9.482 3.636-9.482 8.116.047 2.213.995 4.278 2.569 5.6.49.437.69 1.17.502 1.844v.131l1.168-.395c.141-.041.286-.063.432-.066.187.002.372.038.549.106 1.36.591 2.805.89 4.262.883 5.231 0 9.482-3.624 9.482-8.103z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#prefix__a)">
      <path fill="#4F5B62" d="M0 1h22v22H0z" />
    </g>
  </svg>
)

export default SvgComponent
